import _incodeTime from "../../lib/incodeTime.js";
const incodeTime = _incodeTime;
export default (function addIncode(eventGroup, options) {
  if (!options.incode) {
    return eventGroup;
  }
  if (options.incode === "00:00:00:00") {
    return eventGroup;
  }
  let incodeSec = incodeTime.incodeLabelToMediaSeconds(options.incode, options.frameRate, options.dropFrame);
  if (!Number.isFinite(incodeSec)) {
    return eventGroup;
  }
  eventGroup.events.forEach((event, index, events) => {
    if (event.start === false || event.end === false || event.start === undefined || event.end === undefined) {
      return;
    }
    events[index].start += incodeSec;
    events[index].end += incodeSec;
  });
  return eventGroup;
});